import ApplicationStatus from './components/ApplicationStatus/ApplicationStatus.vue';
import { mapActions, mapState } from 'vuex';
import ApplicationForm from './components/ApplicationForm/ApplicationForm.vue';
import AttachDocuments from './components/AttachDocuments/AttachDocuments.vue';

export default {
  components: { ApplicationForm, AttachDocuments, ApplicationStatus },
  data() {
    return {
      applicationCreated: false,
    };
  },
  computed: {
    ...mapState({
      activeTabName: (state) => state.Applications.activeTabName,
    }),
  },
  watch: {
    applicationCreated() {
      this.setActiveTab('attachDocuments');
    },
  },
  methods: {
    ...mapActions(['setActiveTab']),
  },
};
